import React from "react";
import useAccessCheck from "../../../hooks/useAccessCheck";
import {CompanyRole} from "../../../core/enums/enums";
import {IDocument} from "../../../core/interfaces/document";
import {useMarkDocument} from "../../../api/DocumentApi";
import {Icon} from "../../../assets/Icons/IconClassNames";
import {CustomDropdownItem} from "../../../components/CustomDropdown/CustomDropdownItem/CustomDropdownItem";
import {addToast} from "../../../store/slices/uiSlice";
import {toastInfo} from "../../../core/helpers/toastHelper";
import {useAppDispatch} from "../../../store/hooks";

export const MarkAsImportant = (
    {
        document,
        disabled,
        isEditMode,
        documentId,
    }: { document: IDocument, disabled: boolean, isEditMode: boolean, documentId?: string, }) => {
    const dispatch = useAppDispatch();
    const [checkCompanyRole] = useAccessCheck();
    const [request, isLoading] = useMarkDocument(documentId);

    const handleRequest = async () => {
        if (isEditMode) {
            dispatch(addToast(toastInfo("Lämna redigeringsläge", "Vänligen lämna redigeringsläget.")));
            return;
        }
        await request(!document.important);
    }

    return (<CustomDropdownItem
            disabled={disabled || isLoading || !((checkCompanyRole(CompanyRole.ADMIN)))}
            onClick={handleRequest}
            text={`${document.important ? 'Avmarkera' : 'Markera'} som viktig`}
            icon={Icon.CIRCLE}
            iconColor={"red"}
        />
    )
}